import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, lambda_type, unit_type, bool_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { createReducer, createAction } from "../Redux.js";
import { cons, tail as tail_1, isEmpty, empty } from "../../fable_modules/fable-library.3.7.20/List.js";

export class ModalsAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Info", "Warning", "Error", "Confirm", "Pop"];
    }
}

export function ModalsAction$reflection() {
    return union_type("Redux.Reducers.Modals.ModalsAction", [], ModalsAction, () => [[["Msg", string_type]], [["Msg", string_type]], [["Msg", string_type]], [["Msg", string_type], ["OnCont", lambda_type(bool_type, unit_type)]], []]);
}

export function info(msg) {
    return createAction("ModalsReducer", new ModalsAction(0, msg));
}

export function warning(msg) {
    return createAction("ModalsReducer", new ModalsAction(1, msg));
}

export function error(msg) {
    return createAction("ModalsReducer", new ModalsAction(2, msg));
}

export function confirm(msg, onCont) {
    return createAction("ModalsReducer", new ModalsAction(3, msg, onCont));
}

export const pop = createAction("ModalsReducer", new ModalsAction(4));

export const initState = empty();

function innerReducer(state, action) {
    if (action.tag === 4) {
        if (!isEmpty(state)) {
            return tail_1(state);
        }
        else {
            return state;
        }
    }
    else {
        return cons(action, state);
    }
}

export function reducer(stateOpt, action) {
    return createReducer("ModalsReducer", initState, stateOpt, action, innerReducer);
}

